import styled from 'styled-components'

export const Container = styled.div`
  & > div {
    width: 100%;
  }
`

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 24px;
`

export const IconContainer = styled.div`
  display: grid;
  width: 100%;
  padding: 24px 0;
  justify-items: center;
`

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`
